// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const Search = ({ idRoot }) => (
  <button
    className={'btn search-button big-button'}
    id={`${idRoot}submit`}
    type={'submit'}>
    {'search'}
  </button>
)

Search.propTypes = {
  idRoot: string.isRequired,
}

export default Search
